import React from 'react'
import { Link } from 'react-router-dom'

const MainContent = ({isNotExist, data}) => {
  return (
    <div>
      {
        isNotExist &&
        <div className="text-center lg:py-16">
          <p className="text-lg font-bold mb-3 lg:mb-5">This content is not exist in english</p>
          <Link className="link text-sm" to="/blog/detail?exist=true">Change to Bahasa Indonesia?</Link>
        </div>
      }
      {
        !isNotExist &&
        <div className="blog-content" dangerouslySetInnerHTML={{
          __html: data.content
        }} />
      }
    </div>
  )
}

export { MainContent }